<template>
  <div class="ChallengesAllChallengesSearchBar">
    <div class="container-fluid">
		  <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 h-100 margin-Top-2Perc margin-bottom-2Perc margin-left-1Perc">
            <button type="button" class="btn black-border custom-btn white-BG" @click="createNewChallenge($event,true)">+ Create New</button>
          </div>   
      </div> 
      <create-challenge-overlay v-if="openCreateChallengeOverlay" @closeCreateOverlay="updateCreateChallengeOverlayFlag" @showSpinner="updateShowSpinnerValue"></create-challenge-overlay>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
    </div>
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import CreateChallengeOverlay from '@/components/CreateChallengeOverlay'
export default {
  data: function () {
    return {
      openCreateChallengeOverlay: false,
      showSpinner: false
    }
  },
  methods: {
    createNewChallenge: function (event, flagToUpdate) {
      // AK: Open Create New challenge Overlay
      this.openCreateChallengeOverlay = flagToUpdate
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateCreateChallengeOverlayFlag (value) {
      // AK: used when user closes explicity or performed successfully create challenge operation
      this.openCreateChallengeOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowSpinnerValue (value) {
      // AK: Show / Hide Spinner
      // this.showSpinner = value
      this.$store.state.isLoading = value
    }
  },
  components: {
    'create-challenge-overlay': CreateChallengeOverlay,
    'loader': Loader
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ChallengesAllChallengesSearchBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.margin-Top-2Perc{
  margin-top:2% !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.margin-left-1Perc{
  margin-left: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChallengesAllChallengesSearchBar.vue